import React, { Component } from 'react';
import { createPopper } from '@popperjs/core';

class IconWithTooltip extends Component {
    constructor(props) {
        super(props);

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);

        console.log(this.props.text);

        this.position = typeof props.position !== 'undefined' && props.position.length ? props.position : 'top';
        this.tipRef = React.createRef();
        this.triggerRef = React.createRef();
        this._instance = null;
        this.tipHoverIntentTimeout = 0;
        this.tipHideTimeout = 0;
    }

    componentDidMount() {
        this._instance = createPopper(this.triggerRef.current, this.tipRef.current, {
            placement: this.position,
        });

        this.registerEventListeners();
    }

    registerEventListeners() {
        const showEvents = ['mouseenter', 'focus'];
        const hideEvents = ['mouseleave', 'blur'];

        showEvents.forEach((event) => {
            this.triggerRef.current.addEventListener(event, this.show);
        });

        hideEvents.forEach((event) => {
            this.triggerRef.current.addEventListener(event, this.hide);
        });
    }

    show() {
        this.tipHoverIntentTimeout = setTimeout(() => {
            this.tipRef.current.setAttribute('data-show', '');
            this._instance.update();
        }, 500);
    }

    hide() {
        if (this.tipHideTimeout) clearTimeout(this.tipHideTimeout);
        if (this.tipHoverIntentTimeout) clearTimeout(this.tipHoverIntentTimeout);

        this.tipHideTimeout = setTimeout(() => this.tipRef.current.removeAttribute('data-show'), 3000);
    }

    render () {
        return typeof this.props.icon !== 'undefined' &&
            <div className={"tooltip " + this.props.extraClass}>
                <span className="tooltip__tip" position={this.position} ref={this.tipRef} dangerouslySetInnerHTML={{ __html: this.props.text }}></span>
                <span className="tooltip__trigger" ref={this.triggerRef}>
                    <svg width="0.90em" height="1em"><use xlinkHref={'#' + this.props.icon}></use></svg>
                </span>
            </div>
    }
}

export default IconWithTooltip;